import moment from "moment";
import Game, { WinCondition } from "../Types/Game";

export const apiUrl =
  process.env.NODE_ENV === "production"
    ? `${process.env.REACT_APP_URL}`
    : "http://127.0.0.1:4002";

export const joinStrings = (strings: string[], joinTerm: string) => {
  const stringsCopy = [...strings]; // Neccessary so we do not mutate game.winnerNames!
  const last = stringsCopy.length > 1 ? stringsCopy.pop() : undefined;
  return stringsCopy.join(", ").concat(last ? ` ${joinTerm} ${last}` : "");
};

export const getWinConditionString = (
  t: {
    "number.of.points": string;
    "number.of.rounds": string;
    "first.to": string;
    none: string;
  },
  winCondition: WinCondition,
  winConditionPoints: number,
  winConditionRounds: number
) => {
  switch (winCondition) {
    case "none":
      return undefined;
    case "points":
      return `${t["first.to"]} ${winConditionPoints}${t["number.of.points"]}`;
    case "rounds":
      return `${winConditionRounds}${t["number.of.rounds"]}`;
  }
};

export const isOldGame = (game: Game) =>
  moment(game.created) <= moment().add(-1, "day");

export const getMomentAsString = (moment: moment.Moment) =>
  moment.format("YYYY-MM-DD HH:mm:ss");
